import type { ReactNode } from 'react';
import { styled } from 'styled-components';

import { Icon } from '#/components/Icon/Icon';
import type { IconName } from '#/components/Icon/IconName';
import { useI18n } from '#/i18n/hooks/useI18n';
import { colors, spacing, transition } from '#/theme/theme';

const ViewOrgPageListingsTabsLabelHolder = styled.div`
  display: flex;
  align-items: center;
  padding-left: ${spacing[12]};
  padding-right: ${spacing[12]};

  .tab-label {
    display: flex;
    flex-direction: column;
    font-size: 20px;
    transition: ${transition};
    transition-property: color;
  }

  .tab-count {
    font-size: 16px;
  }

  .tab-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${spacing[40]};
    height: ${spacing[40]};
    background-color: ${colors.elementGrey};
    border-radius: 50%;
    margin-right: ${spacing[16]};
    transition: ${transition};
    transition-property: background-color;

    &[data-selected] {
      background-color: ${colors.brandBlue};
    }
  }
`;

type Props = {
  icon: IconName;
  count: number;
  className?: string;
  children: ReactNode;
  selected?: boolean;
};

export function OrgListingsTabsLabel({
  icon,
  count,
  children,
  selected,
}: Props) {
  const { i18n } = useI18n();

  return (
    <ViewOrgPageListingsTabsLabelHolder>
      <div className="tab-icon" data-selected={selected ? true : undefined}>
        <Icon name={icon} colorName="white" size={24} />
      </div>

      <div className="tab-label">
        {children}
        <div className="tab-count">
          {i18n('%(count)s %(listing)s', {
            count,
            listing: count === 1 ? 'listing' : 'listings',
          })}
        </div>
      </div>
    </ViewOrgPageListingsTabsLabelHolder>
  );
}
